import * as React from "react";
import {useState} from "react";
import {useShareLinksQuery} from "../../../hooks/useShareLinksQuery";
import {FaEnvelope, FaFacebookSquare, FaPinterest} from "react-icons/fa";
import {FaXTwitter} from "react-icons/fa6";
import {EmailModal} from "./emailModal";
import {Button} from "react-bootstrap";
import {url} from "../../../utils/constants";

export const ShareLinks = () => {
    const [show, setShow] = useState<boolean>(false);
    const {sku, title, image} = useShareLinksQuery();

    // If no data, don't render
    if (!title || !sku) return <></>;

    const fbWindowOpen = () => window.open(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`, 'shareWindow', 'menubar=0,toolbar=0,status=0,width=626,height=436')

    const xWindowOpen = () => window.open(`https://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`, 'shareWindow', 'menubar=0,toolbar=0,status=0,width=575,height=450')

    const pinLoad = () => {
        const e = document.createElement('script');
        e.setAttribute('type', 'text/javascript');
        e.setAttribute('charset', 'utf-8');
        e.setAttribute('src', `https://assets.pinterest.com/js/pinmarklet.js?r=${Math.random() * 999999999}`);
        document.body.appendChild(e);
        return false;
    }

    return (
        <>
            <div id="d2g-social-media" className="text-end my-3">
                <span id="gw-share-email">
                    <Button variant="link" onClick={() => setShow(true)} aria-label="Share via Email">
                        <FaEnvelope size={18} aria-hidden="true"/>
                    </Button>
                </span>
                <span id="pin-it-button">
                    <Button onClick={pinLoad} variant="link" aria-label="Share on Pintrest">
                        <FaPinterest size={18} aria-hidden="true"/>
                    </Button>
                </span>
                <span id="fb-share-button">
                    <Button onClick={fbWindowOpen} variant="link" aria-label="Share on Facebook">
                        <FaFacebookSquare size={18} aria-hidden="true"/>
                    </Button>
                </span>
                <span id="x-button">
                    <Button onClick={xWindowOpen} variant="link" aria-label="Share on X">
                        <FaXTwitter size={18} aria-hidden="true"/>
                    </Button>
                </span>
            </div>
            <EmailModal title={title} sku={sku} image={image} show={show} onHide={() => setShow(false)}/>
        </>
    );
};